import { NativeModule, requireOptionalNativeModule } from "expo-modules-core";

import {
  DataWedgeApiModuleEvents,
  CommandArg,
  Intent,
} from "./DataWedgeApi.types";

declare class DataWedgeApiModule extends NativeModule<DataWedgeApiModuleEvents> {
  sendCommand(command: Record<string, CommandArg>): void;

  getInitialIntent(): null | Intent;
}

export default requireOptionalNativeModule<DataWedgeApiModule>(
  "StoresprintDataWedgeApi"
);
